module.exports = __webpack_public_path__ + "static/media/01-04.903a1b2a.mp3";